import type {BookCache, BookSide} from '@/types';

export function genSortedPriceEps(cache: BookCache, side: BookSide) {
  return [...cache.keys()].sort(side === 'Bid' ? bidPriceSorter : askPriceSorter);
}

function bidPriceSorter(a: number, b: number) {
  return b - a;
}

function askPriceSorter(a: number, b: number) {
  return a - b;
}
